import { Box } from '@mui/material';
import AssetItemDetails from './LoaderAssetItem/AssetItemDetails';
import AssetItemChart from './LoaderAssetItem/AssetItemChart';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  enableDarkTheme: boolean;
  item: any;
  selectedSource: string;
  unitSystem: string;
  customerCode: string;
  aggregation: string;
}

const AssetItem = ({
  enableDarkTheme,
  item,
  selectedSource,
  unitSystem,
  customerCode,
  aggregation,
}: Props) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box
      sx={{
        backgroundColor: enableDarkTheme
          ? palette.paperBackground
          : palette.toolBarBackground,
        border: `1px solid ${palette.cardBorderColor}`,
        padding: '16px',
        borderRadius: '8px',
        marginBottom: '10px',
      }}
      data-attribute="assetItemBox"
    >
      <AssetItemDetails
        enableDarkTheme={enableDarkTheme}
        unitSystem={unitSystem}
        device={item}
      />
      <AssetItemChart
        enableDarkTheme={enableDarkTheme}
        selectedSource={selectedSource}
        unitSystem={unitSystem}
        customerCode={customerCode}
        device={item}
        aggregation={aggregation}
      />
    </Box>
  );
};

export default AssetItem;
